import React from 'react';
import Header from '../components/common/Header';
import Banner from '../components/Banner/Banner';
import MainSection from '../components/MainSection';
import Footer from '../components/common/Footer';

const MainPage = () => {
  return (
    <>
      <Header />
      <Banner />
      <MainSection />
      <Footer />
    </>
  );
};

export default MainPage;
